import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class User {
  async getMe() {
    return apiFetch(`${ENV.API_ROUTES.USER}/me`, {
      method: "GET",
    });
  }

  async createUser(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    return apiFetch(ENV.API_ROUTES.USER, {
      method: "POST",
      body: formData,
      expectedStatus: 201,
    });
  }

  async getUsers(active = undefined) {
    return apiFetch(`${ENV.API_ROUTES.USER}?active=${active}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async getPaginatedUsers({
    page = 1,
    pageSize = 10,
    name = "",
    dni = "",
    phone = "",
  } = {}) {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      name,
      dni,
      phone,
    }).toString();
    return apiFetch(`${ENV.API_ROUTES.USER}/paginated?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async getTeachers() {
    return apiFetch(`${ENV.API_ROUTES.USER}/teachers`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async getUsersToReentry(academicCycleId, filters) {
    const queryParams = new URLSearchParams(filters).toString();
    return apiFetch(
      `${ENV.API_ROUTES.USER}/${academicCycleId}/reentry?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  }

  async updateUser(userId, userData) {
    if (!userData.password) {
      delete userData.password;
    }
    const formData = new FormData();
    Object.keys(userData).forEach((key) => {
      formData.append(key, userData[key]);
    });
    return apiFetch(`${ENV.API_ROUTES.USER}/${userId}`, {
      method: "PATCH",
      body: formData,
    });
  }

  async deleteUser(userId) {
    return apiFetch(`${ENV.API_ROUTES.USER}/${userId}`, {
      method: "DELETE",
    });
  }

  async checkEmail(email) {
    return apiFetch(
      `${ENV.API_ROUTES.USER}/check-email?email=${encodeURIComponent(email)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  }

  async changePassword(currentPassword, newPassword) {
    return apiFetch(`${ENV.API_ROUTES.USER}/change-password`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ currentPassword, newPassword }),
    });
  }
}
